import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'skeleton-loading-card-grid',
  templateUrl: './skeleton-loading-card-grid.component.html',
})
export class SkeletonLoadingCardGridComponent implements OnInit, OnChanges {
  @Input() count = 2;

  public placeholders: number[] = [];

  ngOnInit() {
    this.refreshPlaceholders();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.count) {
      this.refreshPlaceholders();
    }
  }

  private refreshPlaceholders() {
    const total = Math.max(1, Number(this.count) || 1);
    this.placeholders = Array.from({ length: total }, (_, index) => index);
  }
}
